import { ElementBuilder } from "@universityofmaryland/web-builder-library";
import * as token from "@universityofmaryland/web-token-library";
import "@universityofmaryland/web-styles-library/element";
import "@universityofmaryland/web-styles-library/layout";
import "@universityofmaryland/web-styles-library/animation";
import "@universityofmaryland/web-styles-library/typography";
import "@universityofmaryland/web-utilities-library/media";
import "@universityofmaryland/web-utilities-library/dom";
import "@universityofmaryland/web-icons-library/controls";
import "@universityofmaryland/web-icons-library/communication";
import "@universityofmaryland/web-icons-library/files";
import "@universityofmaryland/web-icons-library/brand";
import "@universityofmaryland/web-icons-library/arrows";
import "@universityofmaryland/web-utilities-library/performance";
import "@universityofmaryland/web-utilities-library/styles";
import "../../../atomic/animations/brand/card-stack.js";
import { createImageBackground } from "../../../atomic/assets/image/background.js";
import "@universityofmaryland/web-styles-library";
import "@universityofmaryland/web-utilities-library/accessibility";
import "@universityofmaryland/web-icons-library/location";
import "@universityofmaryland/web-icons-library/calendar";
import "@universityofmaryland/web-utilities-library/theme";
import "../../../atomic/layout/block/stacked.js";
import "../../../atomic/layout/person/columns.js";
import "@universityofmaryland/web-icons-library/social";
import "@universityofmaryland/web-utilities-library/string";
import "@universityofmaryland/web-utilities-library/animation";
import "../../../atomic/text-lockup/small.js";
import { createContainer } from "./container.js";
const ANIMATION_TIME = 500;
const PREVIEW_ANIMATION_TIME = 440;
const getAdjacentIndices = (currentIndex, totalSlides) => {
  const lastIndex = totalSlides - 1;
  return {
    leftIndex: currentIndex === 0 ? lastIndex : currentIndex - 1,
    rightIndex: currentIndex === lastIndex ? 0 : currentIndex + 1
  };
};
const positionSlideOffScreen = (slide, direction) => {
  slide.setAttribute("data-direction", direction);
  slide.setAttribute("data-animating", "true");
  slide.offsetHeight;
};
const activateSlideTransition = (slide, direction) => {
  if (direction) {
    slide.setAttribute("data-direction", direction);
  } else {
    slide.removeAttribute("data-direction");
    slide.setAttribute("data-active", "true");
  }
};
const cleanupSlideTransition = (slide, isNew) => {
  if (isNew) {
    slide.removeAttribute("data-animating");
  } else {
    slide.removeAttribute("data-active");
    slide.removeAttribute("data-direction");
    slide.removeAttribute("data-content-visible");
  }
};
const createPreviewElement = (slide) => {
  const imageCopy = slide.image.cloneNode(true);
  const preview = createImageBackground({
    element: imageCopy,
    isScaled: true,
    imageLoading: "lazy"
  });
  preview.element.style.transition = `transform ${PREVIEW_ANIMATION_TIME}ms ease-in-out`;
  return preview.element;
};
const clearPreviewContainer = (container) => {
  while (container.firstChild) {
    container.removeChild(container.firstChild);
  }
};
const appendPreviewWithAnimation = (container, preview, animationDirection) => {
  preview.style.transform = animationDirection === "advance" ? "translateX(100%)" : "translateX(-100%)";
  container.appendChild(preview);
  requestAnimationFrame(() => {
    preview.style.transform = "translateX(0)";
  });
};
const animatePreviewOut = (preview, animationDirection) => {
  return new Promise((resolve) => {
    preview.style.transform = animationDirection === "advance" ? "translateX(-100%)" : "translateX(100%)";
    setTimeout(() => {
      if (preview.parentNode) {
        preview.parentNode.removeChild(preview);
      }
      resolve();
    }, PREVIEW_ANIMATION_TIME);
  });
};
const updatePreviews = (refs, state, direction) => {
  const { currentIndex, slides } = state;
  const { leftIndex, rightIndex } = getAdjacentIndices(
    currentIndex,
    slides.length
  );
  if (slides[leftIndex]) {
    const existingLeft = refs.previews.left.firstElementChild;
    if (existingLeft && direction) {
      animatePreviewOut(existingLeft, direction);
    } else if (existingLeft) {
      clearPreviewContainer(refs.previews.left);
    }
    const leftPreview = createPreviewElement(slides[leftIndex]);
    if (direction) {
      appendPreviewWithAnimation(refs.previews.left, leftPreview, direction);
    } else {
      refs.previews.left.appendChild(leftPreview);
    }
  }
  if (slides[rightIndex]) {
    const existingRight = refs.previews.right.firstElementChild;
    if (existingRight && direction) {
      animatePreviewOut(existingRight, direction);
    } else if (existingRight) {
      clearPreviewContainer(refs.previews.right);
    }
    const rightPreview = createPreviewElement(slides[rightIndex]);
    if (direction) {
      appendPreviewWithAnimation(refs.previews.right, rightPreview, direction);
    } else {
      refs.previews.right.appendChild(rightPreview);
    }
  }
};
const updateInfo = (refs, newIndex) => {
  refs.info.textContent = `Slide ${newIndex + 1} Selected`;
};
const animateSlides = (refs, state, newIndex, direction) => {
  if (state.isAnimating || state.currentIndex === newIndex) return;
  state.isAnimating = true;
  const currentSlide = refs.slides[state.currentIndex];
  const newSlide = refs.slides[newIndex];
  refs.controls.prev.setAttribute("disabled", "");
  refs.controls.next.setAttribute("disabled", "");
  const newSlideDirection = direction === "reverse" ? "left" : "right";
  positionSlideOffScreen(newSlide, newSlideDirection);
  refs.indicator.position(newIndex);
  requestAnimationFrame(() => {
    activateSlideTransition(newSlide);
    const currentSlideDirection = direction === "reverse" ? "right" : "left";
    activateSlideTransition(currentSlide, currentSlideDirection);
    const nextState = { ...state, currentIndex: newIndex };
    updatePreviews(refs, nextState, direction);
  });
  setTimeout(() => {
    cleanupSlideTransition(currentSlide, false);
    cleanupSlideTransition(newSlide, true);
    newSlide.setAttribute("data-content-visible", "true");
    refs.controls.prev.removeAttribute("disabled");
    refs.controls.next.removeAttribute("disabled");
    state.currentIndex = newIndex;
    state.isAnimating = false;
    updateInfo(refs, newIndex);
  }, ANIMATION_TIME);
};
const setupSliderControls = (refs, state) => {
  const lastIndex = state.slides.length - 1;
  refs.controls.prev.addEventListener("click", () => {
    if (state.isAnimating) return;
    const newIndex = state.currentIndex === 0 ? lastIndex : state.currentIndex - 1;
    animateSlides(refs, state, newIndex, "reverse");
  });
  refs.controls.next.addEventListener("click", () => {
    if (state.isAnimating) return;
    const newIndex = state.currentIndex === lastIndex ? 0 : state.currentIndex + 1;
    animateSlides(refs, state, newIndex, "advance");
  });
};
const createCompositeCarouselWide = (props) => {
  const { title } = props;
  const state = {
    currentIndex: 0,
    isAnimating: false,
    slides: props.slides
  };
  const container = createContainer(props, (index) => {
    if (state.isAnimating || state.currentIndex === index) return;
    const direction = state.currentIndex > index ? "reverse" : "advance";
    animateSlides(refs, state, index, direction);
  });
  const carouselTitle = title || "Animated Image Carousel";
  const composite = new ElementBuilder().withClassName("umd-carousel-wide").withAttribute("title", carouselTitle).withStyles({
    element: {
      containerType: "inline-size",
      display: "block",
      position: "relative",
      [`@media (${token.media.queries.large.min})`]: {
        paddingBottom: 0
      }
    }
  }).withChild(container).build();
  const refs = {
    container: composite.element,
    ...container.refs
  };
  requestAnimationFrame(() => {
    setupSliderControls(refs, state);
    updatePreviews(refs, state);
  });
  return composite;
};
export {
  createCompositeCarouselWide
};
//# sourceMappingURL=index.js.map
